import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CompanyCompanyDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json; charset=UTF-8'
    })
  };

  constructor( private http: HttpClient ) { }

  public getCompanyInfo(context, lang,  udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/companyMaintenance/ws_getCompanyDetails', item, options);
  }

  public updateCompany(context, lang,  udid, internalId, city, companyCif, companyName, country, email, faxNumber, fiscalName, phoneNumber, province, region, street, zipCode) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, city, companyCif, companyName, country, email, faxNumber, fiscalName, phoneNumber, province, region, street, zipCode };
    return this.http.post(this.BASE_URL + 'private/v2.0/companyMaintenance/ws_saveCompany', item, options);
  }

  public updateCompanyImage(context, lang, udid, internalId, imageRaw, size) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, imageRaw, size };
    return this.http.post(this.BASE_URL + 'private/v2.0/companyMaintenance/ws_updateImageCompany', item, options);
  }
}
